import {Pipe, PipeTransform} from '@angular/core';
import {NavigationStore} from 'app/shared/store/navigation.store';
import {BimElementStore} from 'app/shared/store/bim-element.store';

/**
 * Renvoie le chemin d'un fichier par rapport à l'espace courant.
 */
@Pipe({name: 'fichierEspaces'})
export class FichierEspacesPipe implements PipeTransform {

    constructor(
        private navigationStore: NavigationStore,
        private bimElementStore: BimElementStore,
    ) {
    }

    transform(fichier: any): string {
        return this.getDocumentPath(fichier, this.bimElementStore.getCurrentElementInfoSnapshot().id);
    }

    /**
     * Renvoie l'arborescence d'espaces d'un document par partir de l'espace passé en paramètre.
     */
    private getDocumentPath(fichier: any, idElement: string): string {
        if (!fichier.element) {
            return null;
        }
        let path = '';
        let parents = fichier.element.parents;
        if (parents && parents.length && idElement) {
            const index = parents.findIndex(parent => parent.id === idElement);
            if (index > -1) {
                parents = parents.slice(0, index);
                if (parents.length) {
                    path = ' / ' + parents.map(parent => parent ? parent.nom : '?').reverse().join(' / ');
                }
                path += ' / ';
            }
        }
        return path + fichier.element.nom;
    }
}
